import types from 'store/types/definitions';
import { API_PATHS } from '../../helpers/endpoints';
import Requester from '../../helpers/requester';
import { HTTP_METHODS } from '../../helpers/constants';
import { getCities, openForSaleStore } from '../requests/definitions';

export default {
  getUsers: (queryString) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.USERS_SEARCH}?${queryString}`,
      });
      dispatch({ type: types.DEFINITIONS_SET, key: 'users', data: response });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getAllUser: (queryString) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.ALL_USER}?${queryString}`,
      });
      dispatch({ type: types.DEFINITIONS_SET, key: 'allUser', data: response });
      return response;
    } catch (error) {
      throw error;
    }
  },

  addUser: (data) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.USERS}`,
        data,
      });
      dispatch({ type: types.DEFINITIONS_SET, key: 'addUser', data: response });
      return response;
    } catch (error) {
      throw error;
    }
  },

  changeUserStore: (data) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PUT,
        url: `${API_PATHS.USERS}/change-active-store-or-region`,
        data,
      });
      dispatch({
        type: types.DEFINITIONS_SET,
        key: 'changeUserStore',
        data: response,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteUser: (id) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.DELETE,
        url: `${API_PATHS.USERS}/${id}`,
        data: { isActive: false },
      });
      dispatch({ type: types.DEFINITIONS_SET });
      return response;
    } catch (error) {
      throw error;
    }
  },

  changeActivateUser: (data) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.USERS}/change-user-status`,
        data: data,
      });
      dispatch({ type: types.DEFINITIONS_SET });
      return response;
    } catch (error) {
      throw error;
    }
  },

  editUser: (data, id) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PUT,
        url: `${API_PATHS.USERS}/${id}`,
        data,
      });
      dispatch({
        type: types.DEFINITIONS_SET,
        key: 'editUser',
        data: response,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  setUserStores: (stores) => {
    return {
      type: types.DEFINITIONS_SET,
      key: 'userStores',
      data: stores,
    };
  },

  setUserRegions: (regions) => {
    return {
      type: types.DEFINITIONS_SET,
      key: 'userRegions',
      data: regions,
    };
  },

  getRoles: () => async (dispatch) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.USER_ROLES}`,
      });
      dispatch({ type: types.DEFINITIONS_SET, key: 'roles', data: response });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getStores: (queryString) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.STORES_SEARCH}?${queryString}`,
      });
      dispatch({ type: types.DEFINITIONS_SET, key: 'stores', data: response });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getAllActiveStores: async () => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.STORES}/all`,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getFirms: (queryString) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.FIRMS_SEARCH}?${queryString}`,
      });
      dispatch({ type: types.DEFINITIONS_SET, key: 'firms', data: response });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getFirmPaymentTypes: () => async (dispatch) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.FIRM_PAYMENT_TYPE_SEARCH}`,
      });
      dispatch({
        type: types.DEFINITIONS_SET,
        key: 'firmPaymentTypes',
        data: response._embedded.firmPaymentTypeResponseDtoList,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getSlotDates: (queryString) => {
    return Requester.submit({
      url: `${API_PATHS.SLOT_DATES_SEARCH}${queryString}`,
    });
  },

  deleteFirm: (id) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.DELETE,
        url: `${API_PATHS.FIRMS}/${id}`,
        data: { isActive: false },
      });
      dispatch({ type: types.DEFINITIONS_SET });
      return response;
    } catch (error) {
      throw error;
    }
  },

  addFirm: (data) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.FIRMS}`,
        data,
      });
      dispatch({ type: types.DEFINITIONS_SET, key: 'addFirm', data: response });
      return response;
    } catch (error) {
      throw error;
    }
  },

  editFirm: (data, id) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PUT,
        url: `${API_PATHS.FIRMS}/${id}`,
        data,
      });
      dispatch({
        type: types.DEFINITIONS_SET,
        key: 'editFirm',
        data: response,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getRegions: (queryString) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.REGIONS_SEARCH}?${queryString}`,
      });
      dispatch({ type: types.DEFINITIONS_SET, key: 'regions', data: response });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getV2Regions: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.REGIONS_SEARCH_V2}${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getRegionsWithoutStore: async (directorateId) => {
    try {
      const response = await Requester.submit({
        url: API_PATHS.REGIONS_WITHOUT_STORE,
        params: {
          filter: `active==true and directorate.id==${directorateId}`,
          page: 0,
          size: 100,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getDirectorates: async () => {
    try {
      const response = await Requester.submit({
        url: API_PATHS.GEORADAR_DIRECTORATE_SEARCH,
        params: {
          page: 0,
          size: 20000,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getRegionsByDirectorate: async (directorateId) => {
    try {
      const filter = directorateId
        ? `active==true and directorate.id==${directorateId}`
        : `active==true`;
      const response = await Requester.submit({
        url: API_PATHS.REGIONS_WITHOUT_STORE,
        params: {
          filter,
          page: 0,
          size: 20000,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getStoresByRegion: async (regionId) => {
    try {
      const response = await Requester.submit({
        url: API_PATHS.STORES_SEARCH_V2,
        params: {
          filter: `region.id==${regionId} and ecomStatus==OPEN`,
          page: 0,
          size: 100,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getActiveStores: async (regionId) => {
    try {
      const filter = regionId
        ? `active==true and region.id==${regionId}`
        : `active==true`;
      const response = await Requester.submit({
        url: API_PATHS.STORES_SEARCH_V2,
        params: {
          filter,
          page: 0,
          size: 20000,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getAllStoresInRegions: async (data) => {
    try {
      const response = await Requester.submit({
        url: `/api/v1/stores/all-in-regions`,
        method: HTTP_METHODS.POST,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getV2Stores: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.STORES_SEARCH_V2}${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getV2Zones: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.ZONES_SEARCH_V2}${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getAllZonesInStores: async (data) => {
    try {
      const response = await Requester.submit({
        url: `/api/v1/zones/all-in-stores`,
        method: HTTP_METHODS.POST,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteRegion: (id) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.DELETE,
        url: `${API_PATHS.REGIONS}/${id}`,
        data: { isActive: false },
      });
      dispatch({ type: types.DEFINITIONS_SET });
      return response;
    } catch (error) {
      throw error;
    }
  },

  addRegion: (data) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.REGIONS}`,
        data,
      });
      dispatch({
        type: types.DEFINITIONS_SET,
        key: 'addRegion',
        data: response,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  editRegion: (data, id) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PUT,
        url: `${API_PATHS.REGIONS}/${id}`,
        data,
      });
      dispatch({
        type: types.DEFINITIONS_SET,
        key: 'editRegion',
        data: response,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  sendLink: (data) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.USERS}/sms-notification`,
        data,
      });
      dispatch({
        type: types.DEFINITIONS_SET,
        key: 'sendLink',
        data: response,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getDownloadLinkForCollector: async () => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.EXCEL_URL}/collector-template`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  excelFileUpload: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.IMPORT_FILE}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getStoreList: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.STORES_SEARCH_ACTIVE_ROLES_V2}?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getShipmentTypes: async () => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.SHIPMENT_TYPES}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getPaymentTypes: async () => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.PAYMENT_TYPES}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  editStore: async (data, code) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PUT,
        url: `${API_PATHS.STORES_V2}/${code}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getBulkDefinitionsTraces: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.BULK_DEFINITIONS_TRACES}?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getDefinitionTrace: async (traceID) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.BULK_DEFINITIONS_TRACES}/${traceID}/items?page=0&size=20000`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getStoreCategoryRankings: async (payload) => {
    const { queryString, ...data } = payload;
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.STORE_CATEGORY_RANKING}?${queryString}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getExcelUrlStoreCategoryRankingTemplate: async () => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.EXCEL_URL}/store-category-ranking-template`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getStoreGroups: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.STORE_GROUPS_SEARCH}?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getStoresOfStoreGroup: async (regionCode, queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.STORES_OF_STORE_GROUP}/${regionCode}?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  importStoreInfo: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.IMPORT_STORE_DATA}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  ImportAllZoneUpdate: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.DATA_IMPORT}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  getDownloadLinkForStoreInfo: async () => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.EXCEL_URL_STORE}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getWaitingApproveStores: async (data) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.STORES_V2}/waiting-approve`,
        method: HTTP_METHODS.POST,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  openForSaleStore: async (storeId) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.STORES_V2}/${storeId}/ecom-status`,
        method: HTTP_METHODS.PATCH,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  openForBulkSaleStore: async (data) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.STORES_V2}/v2/ecom-status`,
        method: HTTP_METHODS.PATCH,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getCancelledItemHistory: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.CANCELLED_ITEM_HISTORY}?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getOrderHistory: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.ORDER_HISTORY}?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  addStoreManager: (data) => async (dispatch) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.PASSIVE_USER_ROLE_STATUS}`,
        data,
      });
      dispatch({
        type: types.DEFINITIONS_SET,
        key: 'addStoreManager',
        data: response,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  downloadTemplateFile: async (code) => {
    try {
      window.location = `/api/data/template/${code}/download`;
    } catch (error) {
      throw error;
    }
  },
  addNotificationDefinition: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.NOTIFICATION_DEFINITIONS}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  deleteNotificationDefinition: async (ids) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.DELETE,
        url: `${API_PATHS.NOTIFICATION_DEFINITIONS}`,
        data: { ids: ids },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  getNotificationDefinitions: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.NOTIFICATION_DEFINITIONS}/search?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  resendNotificationDefinition: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PATCH,
        url: `${API_PATHS.NOTIFICATION_DEFINITIONS}/re-send`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  getCities: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.ALL_CITIES}?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  getAllUsers: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.ALL_USERS}?${queryString}&page=0&size=2000`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  getAllStores: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.ALL_STORES}?${queryString}&page=0&size=2000`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  getAllZones: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.ALL_ZONES}?${queryString}&page=0&size=2000`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  getAllRegions: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.ALL_REGIONS}?${queryString}&page=0&size=2000`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
};
